import { Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import { ReviewProps } from './constants'
import { messages } from './messages'

export function FreeShippingRecap(props: ReviewProps) {
  const { config } = props

  if (!config.benefit || !config.scope) return null

  const { scope } = config

  return (
    <FormattedMessage
      {...messages.freeShipping}
      values={{
        b: (content) => <Text variant="action1">{content}</Text>,
        applyTo: scope.applyTo,
      }}
    />
  )
}
